import { Number } from './number';
import { Text } from './text';

const Typography = {
  Number,
  Text,
};

export { Typography };
